import ReactGA from "react-ga4";



export const useEventos = () => {


/////////////eventos TOPUP

    const tipoOferta = (tipoOfer) => ReactGA.event({
        category: "Consulta",
        action: "abrio promo",
        label: tipoOfer, // uniOferta - multiOferta
      });
    
    const clicPago = (tipoPago) => ReactGA.event({
        category: "Pagos Topup",
        action: "topup pago por PPSS",
        label: tipoPago, // tarjeta - codi
      });
    
      const regresaPago = (respuesta) =>ReactGA.event({
        category: "Pagos Topup",
        action: "topup respuesta PPSS",
        label: respuesta, // message_code
      });
    
    const clicTiendas = () =>ReactGA.event({
        category: "Tiendas",
        action: "buscador tiendas",
        label: 'clic buscador'
      });
    
      const mostrarTiendas = (tipoMuestra) =>ReactGA.event({
        category: "Tiendas",
        action: "abrio locator via",
        label: tipoMuestra, // coordenadas - seleccionador
      });

      const errorToken = (tipoError) =>ReactGA.event({
        category: "Pagos",
        action: "error obtener token",
        label: tipoError, // error mensaje
      });

      /////////////eventos RECARGAS
    
      const clicPagoRecargas = (tipoPago) => ReactGA.event({
        category: "Pagos Recargas",
        action: "recarga por PPSS ",
        label: tipoPago, // tarjeta - codi
      });
    
      const regresaPagoRecargas = (respuesta) =>ReactGA.event({
        category: "Pagos Recargas",
        action: "recarga respuesta PPSS",
        label: respuesta, // message_code
      });
    
      const validaDN = (respuesta) =>ReactGA.event({
        category: "Valida Recargas",
        action: "validacion numero",
        label: respuesta, // exito - error
      });
    
      const seleccionaMonto = (monto) =>ReactGA.event({
        category: "Selecciona Recargas",
        action: "selecciona monto recarga",
        label: monto, // 50, 100
      });
  
  
  
    return {
        tipoOferta,
        clicPago,
        regresaPago,
        clicTiendas,
        mostrarTiendas,
        clicPagoRecargas,
        regresaPagoRecargas,
        validaDN,
        seleccionaMonto,
        errorToken
      }
}



